import React, { useEffect } from 'react'
import { Field, reduxForm } from 'redux-form'
import RadioButtonInput from '../../../containers/Forms/components/RadioButtonInput'
import stylesEkgReview from '../../../containers/EkgRecordingReviewScreen/EkgRecordingReviewScreen.css'
import styles from './MedantaAdhocInterpretation.css'

const labelSpanStyle = {
  verticalAlign: '0.15em',
  marginLeft: '2px',
  fontFamily: 'proxima-nova, Helvetica Neue, helvetica, arial, sans-serif',
  fontSize: '14px',
}

const MedantaAdhocInterpretation = props => {
  const {
    selectedMedantaInterpretations,
    updateMedantaInterpretations,
    medantaInterpretations,
    vendorInterpretation,
    medantaInterpretationForm,
  } = props

  // only once after component mounts
  useEffect(() => {
    // if vendorInterpretation.data is not available - there is no interpretation selected
    // on vendorInterpretation.data available update the selected selectedMedantaInterpretations
    if (vendorInterpretation.data && vendorInterpretation.error === null && medantaInterpretationForm === undefined) {
      updateMedantaInterpretations(vendorInterpretation.data.interpretation)
    }
  }, [ medantaInterpretationForm, updateMedantaInterpretations, vendorInterpretation.data, vendorInterpretation.error ])

  const panelClass = `${stylesEkgReview.addInterpretationsPane} ${styles.actionPanel}`
  return (
    <div className={panelClass}>
      <h2>Medanta’s Interpretation</h2>
      <form>
        <div className={styles.formGroup}>
          <br />
          {
            medantaInterpretations.map(option => (
              <div className={styles.radioField} key={option.value}>
                <Field
                  name="quickInterpretation"
                  component={RadioButtonInput}
                  type="radio"
                  selected={option.quickInterpretationId === selectedMedantaInterpretations.quickInterpretationId}
                  value={option.value}
                  label={option.value}
                  onChange={() => updateMedantaInterpretations(option)}
                  labelSpanStyle={labelSpanStyle}
                  lbelLengthStyel={option.value.length > 40 ? styles.radioText : ''}
                />
              </div>
            ))
          }
        </div>
      </form>
    </div>
  )
}

export default reduxForm({
  form: 'medantaInterpretationForm',
  enableReinitialize: true,
})(MedantaAdhocInterpretation)



// WEBPACK FOOTER //
// ./src/legacy/personalisedPrerequisite/Medanta/components/MedantaAdhocInterpretation.jsx